function initEcSliders() {
  document.querySelectorAll("[data-slider-id]").forEach((sliderElement) => {
    const sliderId = sliderElement.id;
    if (!sliderId || sliderElement.dataset.swiperInitialized) return;

    const swiperContainer = sliderElement.querySelector(".ec-slider-swiper");
    if (!swiperContainer) return;

    const computedStyle = window.getComputedStyle(sliderElement);
    const productsPerPageRaw = computedStyle
      .getPropertyValue("--products-per-page")
      .trim();
    const gapRaw = computedStyle.getPropertyValue("--gap").trim();
    const gapMobileRaw = computedStyle.getPropertyValue("--gap-mobile").trim();

    const productsPerPage = productsPerPageRaw
      ? parseInt(productsPerPageRaw)
      : 4;
    const productsPerPageTablet = Math.min(3, productsPerPage);
    const gap = gapRaw ? parseInt(gapRaw.replace("px", "")) : 20;
    const gapMobile = gapMobileRaw
      ? parseInt(gapMobileRaw.replace("px", ""))
      : gap;

    const spvDesktopRaw = sliderElement.dataset.slidesPerViewDesktop;
    const spvMobileRaw = sliderElement.dataset.slidesPerViewMobile;
    const spgDesktopRaw = sliderElement.dataset.slidesPerGroupDesktop;
    const spgMobileRaw = sliderElement.dataset.slidesPerGroupMobile;
    const spaceDesktopRaw = sliderElement.dataset.spaceBetweenDesktop;
    const spaceMobileRaw = sliderElement.dataset.spaceBetweenMobile;

    const spvDesktop = spvDesktopRaw === 'auto' ? 'auto' : (spvDesktopRaw ? parseFloat(spvDesktopRaw) : productsPerPage);
    const spvMobile = spvMobileRaw === 'auto' ? 'auto' : (spvMobileRaw ? parseFloat(spvMobileRaw) : 2);
    const spvTablet = spvDesktopRaw === 'auto' ? 'auto' : (spvDesktopRaw ? Math.min(3, Math.floor(spvDesktop)) : productsPerPageTablet);

    const spgDesktopAuto = spvDesktop === 'auto';
    const spgMobileAuto = spvMobile === 'auto';
    const spgTabletAuto = spvTablet === 'auto';

    const spgDesktop = spgDesktopAuto ? 1 : (spgDesktopRaw ? parseInt(spgDesktopRaw) : spvDesktop);
    const spgMobile = spgMobileAuto ? 1 : (spgMobileRaw ? parseInt(spgMobileRaw) : 2);
    const spgTablet = spgTabletAuto ? 1 : spvTablet;

    const spaceDesktop = spaceDesktopRaw ? parseInt(spaceDesktopRaw) : gap;
    const spaceMobile = spaceMobileRaw ? parseInt(spaceMobileRaw) : gapMobile;

    const slides = swiperContainer.querySelectorAll(".swiper-slide");
    if (slides.length === 0) return;

    const counterCurrent = sliderElement.querySelector(".ec-slider-counter--current");
    const counterTotal = sliderElement.querySelector(".ec-slider-counter--total");

    const updateCounter = function (swiperInstance) {
      const totalSlides = swiperInstance.slides.length;
      const slidesPerGroup = swiperInstance.params.slidesPerGroup || 1;
      const totalPages = Math.ceil(totalSlides / slidesPerGroup) || 1;
      const currentPage = Math.min(
        Math.floor(swiperInstance.activeIndex / slidesPerGroup) + 1,
        totalPages
      );

      if (counterCurrent) counterCurrent.textContent = currentPage;
      if (counterTotal) counterTotal.textContent = totalPages;
    };

    const noSwipeMobile = sliderElement.classList.contains("ec-slider--no-swipe-mobile");
    const getAllowTouchMove = () => !noSwipeMobile || window.innerWidth >= 750;

    const isCssDriven = sliderElement.dataset.slidesPerViewDesktop === 'auto';

    if (isCssDriven) {
      const updateParamsFromCSS = function (swiperInstance) {
        const computed = window.getComputedStyle(sliderElement);
        const isMobile = window.innerWidth < 750;
        
        let productsPerPage = 4;
        let productsPerPageGroup = 4;
        let space = 20;
        
        const gapRaw = computed.getPropertyValue("--gap").trim();
        const gapMobileRaw = computed.getPropertyValue("--gap-mobile").trim();
        const productsPerPageRaw = computed.getPropertyValue("--products-per-page").trim();
        const productsPerPageMobileRaw = computed.getPropertyValue("--products-per-page-mobile").trim();
        
        if (isMobile) {
          if (productsPerPageMobileRaw) {
            productsPerPage = parseFloat(productsPerPageMobileRaw);
          } else if (productsPerPageRaw) {
            productsPerPage = parseFloat(productsPerPageRaw);
          } else {
            productsPerPage = 2;
          }
          productsPerPageGroup = productsPerPageRaw ? parseInt(productsPerPageRaw) : Math.floor(productsPerPage);
          space = gapMobileRaw ? parseInt(gapMobileRaw.replace("px", "")) : 10;
        } else {
          if (productsPerPageRaw) {
            productsPerPage = parseFloat(productsPerPageRaw);
          }
          productsPerPageGroup = Math.floor(productsPerPage);
          space = gapRaw ? parseInt(gapRaw.replace("px", "")) : 20;
        }
        
        if (isNaN(productsPerPage)) productsPerPage = 4;
        if (isNaN(productsPerPageGroup)) productsPerPageGroup = 4;
        if (isNaN(space)) space = 20;
        
        swiperInstance.params.slidesPerView = productsPerPage;
        swiperInstance.params.slidesPerGroup = productsPerPageGroup;
        swiperInstance.params.spaceBetween = space;
        
        swiperInstance.update();
      };

      const swiper = new Swiper(swiperContainer, {
        loop: false,
        speed: 600,
        allowTouchMove: getAllowTouchMove(),
        navigation: {
          nextEl: sliderElement.querySelector(".swiper-button-next"),
          prevEl: sliderElement.querySelector(".swiper-button-prev"),
        },
        pagination: {
          el: sliderElement.querySelector(".swiper-pagination"),
          clickable: true,
          renderBullet: function (index, className) {
            return (
              '<button class="' +
              className +
              '" aria-label="Ir para página ' +
              (index + 1) +
              '"></button>'
            );
          },
        },
        on: {
          init: function () {
            sliderElement.dataset.swiperInitialized = "true";
            updateParamsFromCSS(this);
            updateCounter(this);
          },
          resize: function () {
            updateParamsFromCSS(this);
            updateCounter(this);
            if (noSwipeMobile) {
              this.allowTouchMove = getAllowTouchMove();
            }
          }
        }
      });

      swiper.on("slideChange", function () {
        updateCounter(swiper);
      });
      swiper.on("slideChangeTransitionEnd", function () {
        updateCounter(swiper);
      });

      if (noSwipeMobile) {
        window.addEventListener("resize", function onResize() {
          swiper.allowTouchMove = getAllowTouchMove();
        });
      }

      sliderElement.swiperInstance = swiper;

    } else {
      const swiper = new Swiper(swiperContainer, {
        slidesPerView: spvDesktop,
        spaceBetween: spaceDesktop,
        slidesPerGroup: spgDesktop,
        slidesPerGroupAuto: spgDesktopAuto,
        loop: false,
        speed: 600,
        allowTouchMove: getAllowTouchMove(),
        navigation: {
          nextEl: sliderElement.querySelector(".swiper-button-next"),
          prevEl: sliderElement.querySelector(".swiper-button-prev"),
        },
        pagination: {
          el: sliderElement.querySelector(".swiper-pagination"),
          clickable: true,
          renderBullet: function (index, className) {
            return (
              '<button class="' +
              className +
              '" aria-label="Ir para página ' +
              (index + 1) +
              '"></button>'
            );
          },
        },
        breakpoints: {
          1200: {
            slidesPerView: spvDesktop,
            slidesPerGroup: spgDesktop,
            slidesPerGroupAuto: spgDesktopAuto,
            spaceBetween: spaceDesktop,
          },
          750: {
            slidesPerView: spvTablet,
            slidesPerGroup: spgTablet,
            slidesPerGroupAuto: spgTabletAuto,
            spaceBetween: spaceDesktop,
          },
          0: {
            slidesPerView: spvMobile,
            slidesPerGroup: spgMobile,
            slidesPerGroupAuto: spgMobileAuto,
            spaceBetween: spaceMobile,
          },
        },
        on: {
          init: function () {
            sliderElement.dataset.swiperInitialized = "true";
            updateCounter(this);
          },
        },
      });

      swiper.on("slideChange", function () {
        updateCounter(swiper);
      });
      swiper.on("slideChangeTransitionEnd", function () {
        updateCounter(swiper);
      });
      swiper.on("breakpoint", function () {
        updateCounter(swiper);
        if (noSwipeMobile) {
          swiper.allowTouchMove = getAllowTouchMove();
        }
      });

      if (noSwipeMobile) {
        window.addEventListener("resize", function onResize() {
          swiper.allowTouchMove = getAllowTouchMove();
        });
      }

      sliderElement.swiperInstance = swiper;
    }
  });
}

function waitForSwiper() {
  if (typeof Swiper !== "undefined") {
    initEcSliders();
  } else {
    setTimeout(waitForSwiper, 100);
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", waitForSwiper);
} else {
  waitForSwiper();
}
